export function setFieldState(id, value) {
    return (dispatch) => {
        dispatch({
            type: 'FIELD_STATE_SAVE_TERM', payload: {
                id,
                value
            }
        })
    }
}